import React, { useCallback, useEffect, useRef, useState } from 'react';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';
import { useHistory, useParams, useRouteMatch, generatePath } from 'react-router-dom';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';

import CategoryHeader from './GameCategoryComponents/CategoryHeader';
import CategoryPCCard from '../../../components/Game/CategoryPCCard/CategoryPCCard';
import CategoryACard from '../../../components/Game/CategoryACard/CategoryACard';
import CategoryList from '../../../components/Game/CategoryList/CategoryList';
import {
  setSelectedTag,
  setSelectedATag,
  getTagAppList,
  setGameCategoryTag,
} from '../../../actions/game';
import { logging, logPostInfo } from '../../../actions/log';
import Loading from '../../../components/Loading/Loading';
import styles from './GameCategory.module.less';
import DefaultImg from '../../../static/game/game_default.png';
import ScrollTop from '../../../components/ScrollTop/ScrollTop';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const SelectGameCategoryShow = createSelector(
  state => state.game,
  game => game.categoryShow,
);

const SelectGameSelectTag = createSelector(
  state => state.game,
  game => game.categorySelectedTag,
);

const SelectGameCode = createSelector(
  state => state.game,
  game => game.gameSelectCode,
);

const SelectGameSort = createSelector(
  state => state.game,
  game => game.gameSort,
);

const SelectGameList = createSelector(
  state => state.game,
  game => game.gameAppList,
);

const SelectGameLoading = createSelector(
  state => state.game,
  game => game.gameListLoading,
);

function GameCategory({ source, scrollAdv }) {
  const dispatch = useDispatch();
  const { code } = useParams();
  const categoryShow = useSelector(SelectGameCategoryShow);
  const gameSelectTag = useSelector(SelectGameSelectTag);
  const gameCode = useSelector(SelectGameCode);
  const gameSort = useSelector(SelectGameSort);
  const gameList = useSelector(SelectGameList);
  const gameLoading = useSelector(SelectGameLoading);
  const logInfoData = useSelector(selectLogInfo);
  const [initTime, setInitTime] = useState(Date.now());
  const [showData, setShowData] = useState([]);
  // 每行展示游戏个数
  const [showNum, setShowNum] = useState(3);
  // 页面的宽高，用于传入组件使用
  const [nodeStyle, setNodestyle] = useState({ width: 852, height: 600 });
  const node = useRef(null);
  const listNodeRef = useRef(null);

  const getPVLog = useCallback(() => {
    dispatch(
      logging({
        category: 'P',
        action: source,
        label: '',
        param2: {
          source: code ? `${source}||${code}` : source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: code ? `${source}||${code}` : source,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, []);

  const getUVlog = () => {
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime: initTime,
          leaveTime: Date.now(),
          time: Math.ceil(Date.now() - initTime),
        },
      }),
    );
  };

  useEffect(() => {
    getPVLog();
    setInitTime(Date.now());
  }, []);
  useActivate(() => {
    getPVLog();
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    getUVlog();
  });

  useEffect(() => {
    dispatch(setGameCategoryTag(true));
  }, []);

  useEffect(() => {
    switch (showNum) {
      case 3:
        setShowData(gameList.list3);
        break;
      case 4:
        setShowData(gameList.list4);
        break;
      case 5:
        setShowData(gameList.list5);
        break;
      case 6:
        setShowData(gameList.list6);
        break;
    }
  }, [showNum, gameList]);

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    let pcList = [];
    let AList = [];
    if (gameCode === '1') {
      pcList = gameSelectTag.map(i => i.tagId);
    } else {
      AList = gameSelectTag.map(i => i.childCode);
    }
    if (gameCode) {
      dispatch(
        getTagAppList({
          code: gameCode,
          tagIdList: gameCode === '1' ? pcList : [],
          childCodeList: gameCode === '2' ? AList : [],
          sort: gameSort,
          skip: 0,
          limit: 24,
          refresh: true,
        }),
      );
    }
  }, [gameCode, gameSelectTag, gameSort]);

  const handleResize = useCallback(() => {
    const clientWidth = (document.body && document.body.clientWidth) || 1060;
    const clientHeight = (document.body && document.body.clientHeight) || 680;
    let width = 180 + 8;
    let height = 200;
    if (clientWidth >= 1060 && clientWidth < 1335) {
      setShowNum(3);
    } else if (clientWidth >= 1335 && clientWidth < 1610) {
      setShowNum(4);
    } else if (clientWidth >= 1610 && clientWidth < 1885) {
      setShowNum(5);
    } else if (clientWidth >= 1885) {
      setShowNum(6);
    }
    setNodestyle({
      width: clientWidth - width,
      height: clientHeight - height,
    });
  }, []);

  const handleDel = useCallback(
    info => {
      if (gameCode === '1') {
        dispatch(setSelectedTag({ code: gameCode, info: info }));
      } else {
        dispatch(setSelectedATag({ code: gameCode, info: info }));
      }
    },
    [gameCode],
  );

  const Row = useCallback(
    ({ index, style }) => {
      if (gameCode === '1') {
        return (
          <div
            style={{
              ...style,
              width: `calc(100% - 66px)`,
              height: '235px',
              paddingLeft: '40px',
              paddingRight: '26px',
              overflow: `hidden`,
              marginBottom: `25px`,
              left: '50%',
              transform: `translate(-50%)`,
              maxWidth: '1660px',
              minWidth: '800px',
              display: `grid`,
              marginLeft: '-4px',
            }}
            className={styles.category_pc_info}
          >
            {showData[index].map((item, i) => {
              return (
                <CategoryPCCard
                  key={i}
                  soft={item}
                  logInfo={{ ...logInfoData, tag: source, clTag: 'Game' }}
                />
              );
            })}
          </div>
        );
      } else {
        if (index === 0) {
          return (
            <>
              <div className="head_line" />
              <div
                style={{
                  ...style,
                  top: style.top + 18,
                  width: `calc(100% - 66px)`,
                  height: '48px',
                  // paddingLeft: '40px',
                  // paddingRight: '26px',
                  paddingLeft: '40px',
                  paddingRight: '26px',
                  overflow: `hidden`,
                  marginBottom: `25px`,
                  left: '50%',
                  transform: `translate(-50%)`,
                  maxWidth: '1660px',
                  minWidth: '800px',
                  display: `grid`,
                  marginLeft: '-4px',
                }}
                className={styles.category_a_info}
              >
                {showData[index].map((item, i) => {
                  return (
                    <CategoryACard
                      key={i}
                      soft={item}
                      logInfo={{ ...logInfoData, tag: source, clTag: 'Game' }}
                    />
                  );
                })}
              </div>
            </>
          );
        } else {
          return (
            <div
              style={{
                ...style,
                top: style.top + 18,
                width: `calc(100% - 66px)`,
                height: '48px',
                // paddingLeft: '40px',
                // paddingRight: '26px',

                paddingLeft: '40px',
                paddingRight: '26px',
                overflow: `hidden`,
                marginBottom: `25px`,
                left: '50%',
                transform: `translate(-50%)`,
                maxWidth: '1660px',
                minWidth: '800px',
                display: `grid`,
                marginLeft: '-4px',
              }}
              className={styles.category_a_info}
            >
              {showData[index].map((item, i) => {
                return (
                  <CategoryACard key={i} soft={item} logInfo={{ ...logInfoData, tag: source }} />
                );
              })}
            </div>
          );
        }
      }
    },
    [showNum, showData, gameCode],
  );

  const loadMore = () => {
    let pcList = [];
    let AList = [];
    if (gameCode === '1') {
      pcList = gameSelectTag.map(i => i.tagId);
    } else {
      AList = gameSelectTag.map(i => i.childCode);
    }

    if (gameList.hasNextPage === 1) {
      dispatch(
        getTagAppList({
          code: gameCode,
          tagIdList: gameCode === '1' ? pcList : [],
          childCodeList: gameCode === '2' ? AList : [],
          sort: gameSort,
          skip: gameList?.apps.length,
          limit: 24,
          refresh: false,
        }),
      );
    }
  };

  const showDataCount = () => {
    return gameList.hasNextPage === 1 ? showData.length + 1 : showData.length;
  };

  return (
    <div
      className={styles.page}
      ref={node}
      data-source={source}
      onScroll={() => {
        if (scrollAdv && typeof scrollAdv === 'function') {
          scrollAdv();
        }
      }}
    >
      <CategoryHeader />
      {gameSelectTag.length > 0 && (
        <div className="select_tag">
          <div className="select_tag_title">已选标签：</div>
          {gameSelectTag.map((tag, index) => (
            <div key={index} className="select_tag_show">
              {tag.childName ?? tag.tagName}
              <i className="iconfont icon-task_cancel" onClick={() => handleDel(tag)} />
            </div>
          ))}
        </div>
      )}

      {gameLoading && gameSelectTag?.length === 0 && (
        <div className={styles.no_apps}>
          <Loading styleType={'black'} />
        </div>
      )}
      {!gameLoading && gameCode?.length !== 0 && (
        <>
          {showData.length === 0 && (
            <div className={styles.no_apps}>
              <img src={DefaultImg} className={styles.no_apps_img} />
              <div>找不到符合要求的结果</div>
            </div>
          )}
          {showData.length > 0 && (
            <div className={`page_lists`}>
              <InfiniteLoader
                isItemLoaded={index => {
                  return !!showData[index];
                }}
                itemCount={10000}
                loadMoreItems={loadMore}
              >
                {({ onItemsRendered, ref }) => {
                  return (
                    <List
                      height={nodeStyle.height}
                      itemCount={showData?.length}
                      itemSize={gameCode === '1' ? 250 : 76}
                      width={nodeStyle.width}
                      onItemsRendered={onItemsRendered}
                      ref={list => {
                        ref(list);
                        listNodeRef.current = list;
                      }}
                    >
                      {Row}
                    </List>
                  );
                }}
              </InfiniteLoader>
              {showData.length > 10 && listNodeRef?.current?._outerRef && (
                <ScrollTop node={listNodeRef.current._outerRef} quickly={true} />
              )}
            </div>
          )}
        </>
      )}

      {categoryShow && <CategoryList />}
    </div>
  );
}

export default props => {
  return (
    <KeepAlive id={`game${props.code}`} name={`game${props.code}`} saveScrollPosition="screen">
      <GameCategory {...props} />
    </KeepAlive>
  );
};
